import { Box } from "@mui/material";
import LabelWithValue from "components/LabelWithValue";
import TitleWithOptions from "components/TitleWithOptions";
import { DATE_FORMAT } from "constants/index";
import { TMemberDetails } from "models/member";
import moment from "moment";

export default function MembershipSection(props: {
  member: TMemberDetails;
  editCallback: Function;
}) {
  const { member, editCallback } = props;
  //console.log(`member:\n`, member);
  return (
    <>
      <TitleWithOptions title="Membership" buttonClass="white-background" edit={editCallback} />
      <Box display="flex" gap={1} flexDirection="column" mt={2}>
        <LabelWithValue label="FitLinxx ID" value={member?.membership.fitlinxx_id.toString()} />
        <LabelWithValue
          label="Other Member ID"
          value={member?.membership.other_member_id || `N/A`}
        />
        <LabelWithValue label="Home Facility" value={member?.membership.home_facility || `N/A`} />
        <LabelWithValue
          label="Sign Up Date"
          value={moment(new Date(member?.membership.sign_up_date)).format(DATE_FORMAT)}
        />
        <LabelWithValue
          label="Expiration Date"
          value={
            member?.membership.expiration_date && member?.status != "FITLINXX_FREE"
              ? moment(new Date(member?.membership.expiration_date)).format(DATE_FORMAT)
              : `N/A`
          }
        />
        <LabelWithValue
          label="Cancellation Date"
          value={
            member?.membership.cancellation_date && member?.status != "FITLINXX_FREE"
              ? moment(new Date(member?.membership.cancellation_date)).format(DATE_FORMAT)
              : `N/A`
          }
        />
        <LabelWithValue
          label="Cancellation Reason"
          value={
            member?.membership.cancellation_reason && member?.status != "FITLINXX_FREE"
              ? member?.membership.cancellation_reason
              : `N/A`
          }
        />
      </Box>
    </>
  );
}
